import { Row } from "@components/Flex";
import { Body } from "@components/Typography";
import { getFullName, getInitials } from "@utils";
import { ContactLogo } from "./ContactLogo";
import { useStyles } from "./styles";
import { ContributorCardProps } from "./types";

export const ContributorCard = ({ firstName, lastName, color }: ContributorCardProps) => {
  const styles = useStyles();

  const initials = getInitials(firstName, lastName);
  const name = getFullName(firstName, lastName);
  return (
    <Row style={styles.container}>
      <ContactLogo initials={initials} color={color} />
      <Body style={styles.name}>{name}</Body>
    </Row>
  );
};
